export default __webpack_public_path__ + "static/media/selenium-cucumber.842094ed.png";